import { useEffect, useState } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import DataTable from "examples/Tables/DataTable";
import commissionsTableData from "./CommissionTableData";
import TextField from "@mui/material/TextField";
import MDButton from "components/MDButton";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import RowsPerPageSelector from "components/RowsPerPageSelector";
import AddCommissionModal from "components/AddCommissionModel";
import { Box } from "@mui/material";
// import AddCommissionModal from "components/AddCommissionModal"; // قم بإنشاء هذا المكون لاحقاً

function CommissionsSection() {
  const [commissions, setCommissions] = useState([]);
  const [search, setSearch] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [currentCommission, setCurrentCommission] = useState(null);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleEditClick = (commission) => {
    setCurrentCommission(commission);
    setModalOpen(true);
  };

  useEffect(() => {
    fetchCommissions();
  }, []);

  // show all commissions , with pagination , search by id or amount
  const fetchCommissions = async () => {
    setLoading(true);
    const token = localStorage.getItem("user-token");
    try {
      const response = await fetch(
        "https://back.al-balad.sa/albalad/v1.0/administrator/commissions",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      setCommissions(data.data || []);
    } catch (error) {

    }
    setLoading(false);
  };

  const { columns, rows } = commissionsTableData(commissions, handleEditClick, fetchCommissions);

  // البحث حسب المعرف أو المبلغ
  const filteredRows = rows.filter((row, index) => {
    const searchLower = search.toLowerCase();
    const commission = commissions[index];

    return (
      commission?.id?.toString().includes(searchLower) ||
      commission?.base_amount?.toString().includes(searchLower) ||
      commission?.calculated_commission?.toString().includes(searchLower) ||
      commission?.order?.total?.toString().includes(searchLower)
    );
  });

  const paginatedRows = filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  useEffect(() => {
    setPage(0);
  }, [search, rowsPerPage]);

  return (
    <>
      <Backdrop open={loading} sx={{ zIndex: 2000, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      {/* قم بإلغاء التعليق عند إنشاء المكون */}
      {
        <AddCommissionModal
          open={modalOpen}
          onClose={() => {
            setModalOpen(false);
            setCurrentCommission(null);
          }}
          onCommissionAdded={fetchCommissions}
          initialData={currentCommission}
        />
      }

      <MDBox pt={6} pb={3}>
        <Card>
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            borderRadius="lg"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              background: "linear-gradient(90deg, #ca9937, #e0b15a)",
              boxShadow: 3,
            }}
          >
            <MDTypography variant="h6" color="white">
              قائمة العمولات
            </MDTypography>

            {/*  <MDButton
              variant="contained"
              color="white"
              startIcon={<AddIcon />}
              sx={{ color: "white" }}
              onClick={() => setModalOpen(true)}
            >
              عمولة جديدة
            </MDButton> */}
          </MDBox>

          <Box pt={3} px={2}>
            <TextField
              fullWidth
              label="بحث بالمعرف أو المبلغ"
              variant="outlined"
              size="small"
              sx={{ mb: 3 }}
              onChange={(e) => setSearch(e.target.value)}
            />

            {/* مكون اختيار عدد الصفوف */}
            <MDBox mb={2} display="flex">
              <RowsPerPageSelector value={rowsPerPage} onChange={setRowsPerPage} />
            </MDBox>

            <DataTable
              table={{ columns, rows: paginatedRows }}
              isSorted={false}
              entriesPerPage={false}
              showTotalEntries={true}
              noEndBorder
              sx={{
                "& .MuiTable-root": { minWidth: 1000 },
                "& .MuiTableCell-root": {
                  py: 1.5,
                  borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
                },
                "& .MuiTableHead-root": {
                  backgroundColor: (theme) => theme.palette.grey[100],
                },
              }}
            />

            
          </Box>
        </Card>
      </MDBox>
      {/* أزرار التحكم في الصفحات */}
            <MDBox display="flex" justifyContent="center" mt={4} pb={4} px={2}>
              <MDButton
                onClick={() => setPage((prev) => Math.max(prev - 1, 0))}
                disabled={page === 0}
                sx={{
                  background: "linear-gradient(90deg, #ca9937, #e0b15a)",
                  color: "text",
                  borderRadius: "50%",
                  width: "50px",
                  height: "50px",
                  minWidth: "50px",
                  mx: 1,
                  "&:hover": {
                    background: "linear-gradient(90deg, #b6842f, #d39d45)",
                  },
                }}
              >
                <ArrowForwardIcon />
              </MDButton>

              <MDTypography
                variant="button"
                color="text"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  mx: 3,
                  fontWeight: "bold",
                }}
              >
                 {page + 1} / {Math.ceil(filteredRows.length / rowsPerPage) || 1}
              </MDTypography>

              <MDButton
                onClick={() =>
                  setPage((prev) =>
                    (prev + 1) * rowsPerPage >= filteredRows.length ? prev : prev + 1
                  )
                }
                disabled={(page + 1) * rowsPerPage >= filteredRows.length}
                sx={{
                  background: "linear-gradient(90deg, #ca9937, #e0b15a)",
                  color: "text",
                  borderRadius: "50%",
                  width: "50px",
                  height: "50px",
                  minWidth: "50px",
                  mx: 1,
                  "&:hover": {
                    background: "linear-gradient(90deg, #b6842f, #d39d45)",
                  },
                }}
              >
                <ArrowBackIcon />
              </MDButton>
            </MDBox>
    </>
  );
}

export default CommissionsSection;
